$(function () {
  const $intro = $('#cfl-ms-25-intro');
  const $char  = $('.characters');

  if (!$intro.length || !$char.length) return;

  // Ẩn ngay từ đầu
  $char.hide();

  const target = $intro[0];
  const io = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && entry.intersectionRatio > 0) {
        // Lần đầu container vào viewport → hiện + animate
        $char.show().addClass('animate__slideInRight');
        obs.unobserve(target); // ngắt luôn cho đỡ rình
      }
    });
  }, {
    root: null,         // viewport của trang
    threshold: 0.15,    // ~15% vào khung là đủ
    rootMargin: '0px'
  });

  io.observe(target);
});